import { connect } from 'react-redux';

import { StoreState } from '../../../reducers';
import FromFile from '../../../components/PublicationCreator/FromFile';
import { PublicationCreationStatus } from '../reducer';

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		publicationCreator: {
			fromFile: {
				status,
				percentage,
				error,
			},
		},
	} = state;

	return {
		...ownProps,
		isImportingFile: status && [
			PublicationCreationStatus.IMPORTING,
			PublicationCreationStatus.PROCESSING,
		].includes(status),
		importingStatus: status,
		importingPercentage: percentage,
		importingError: error,
	};
};

export default connect(mapStateToProps)(FromFile);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/PublicationCreator/FromFile/index.tsx